module.exports = __webpack_public_path__ + "img/timestudy-10.228ee556.png";